import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import toNumber from 'lodash/toNumber';
import isNil from 'lodash/isNil';
import isInteger from 'lodash/isInteger';
import isNumber from 'lodash/isNumber';
import { SuiTextInput } from '@splashthat/sui';

import { getFormNodeConfigValue } from 'common/entities/formNode/selectors';
import { NUMBER_MIN, NUMBER_MAX } from 'common/entities/formNode/nodeConfig';

import { updateFormNodeConfigValue } from '../../../actions/nodeActions';

const NumberRangeContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: baseline;
    justify-content: start;
`;

const MinimumInputStyled = styled(SuiTextInput)`
    flex: 1;
    max-width: 7rem;
    margin-right: 2.75rem;
`;

const MaximumInputStyle = styled(SuiTextInput)`
    flex: 1;
    max-width: 7rem;
`;

const MINIMUM_LABEL = 'Minimum';
const MAXIMUM_LABEL = 'Maximum';

const NumberRange = (props) => {
    const dispatch = useDispatch();
    const updateConfig = useCallback(
        (key, value) => dispatch(updateFormNodeConfigValue(props.formNodeId, key, value)),
        [dispatch],
    );
    const roundDecimals = (value) => (isNumber(value) && !isInteger(value) ? value.toFixed(2) : value);

    const min = useSelector((state) => getFormNodeConfigValue(state, props.formNodeId, NUMBER_MIN));
    const max = useSelector((state) => getFormNodeConfigValue(state, props.formNodeId, NUMBER_MAX));

    return (
        <NumberRangeContainer>
            <MinimumInputStyled
                label={MINIMUM_LABEL}
                onChange={(_, value) => updateConfig(NUMBER_MIN, value ? toNumber(value) : null)}
                onBlur={() =>
                    !isNil(min) && !isNil(max) && min >= max
                        ? updateConfig(NUMBER_MIN, max - 1)
                        : updateConfig(NUMBER_MIN, roundDecimals(min))
                }
                value={isNil(min) ? '' : min}
                placeholder="-∞"
                autoComplete="off"
                fullWidth
                type="number"
                step="0.01"
            />
            <MaximumInputStyle
                label={MAXIMUM_LABEL}
                onChange={(_, value) => updateConfig(NUMBER_MAX, value ? toNumber(value) : null)}
                onBlur={() =>
                    !isNil(min) && !isNil(max) && min >= max
                        ? updateConfig(NUMBER_MAX, min + 1)
                        : updateConfig(NUMBER_MAX, roundDecimals(max))
                }
                value={isNil(max) ? '' : max}
                placeholder="∞"
                autoComplete="off"
                fullWidth
                type="number"
                step="0.01"
            />
        </NumberRangeContainer>
    );
};

NumberRange.propTypes = {
    formNodeId: PropTypes.string.isRequired,
};

NumberRange.defaultProps = {};

export default NumberRange;
